<template>
  <div class="btm-nav max-w-[480px] mx-auto static lg:!hidden rounded-t-2xl overflow-hidden" :class="backgroundColor">
    <router-link :to="{name: 'product'}" class="text-white">
      <HomeIcon  class="w-6 h-6" />
      <span class="btm-nav-label text-sm">{{__('Products')}}</span>
    </router-link>
    <router-link :to="{name:'product.special'}" class="text-white bg-red-custom-2 animate-pulse">
      <PercentBadgeIcon  class="w-6 h-6" />
      <span class="btm-nav-label text-sm">{{specialTitle}}</span>
    </router-link>
    <router-link :to="{name: 'cart.info'}" class="text-white">
      <ShoppingBagIcon  class="w-6 h-6" />
      <span class="btm-nav-label text-sm">{{__('Cart')}}</span>
      <div class="badge badge-error w-5 h-5 absolute top-0 left-5" v-if="user.cart?.count > 0">{{user.cart?.count}}</div>
    </router-link>
    <router-link :to="{name:'notification'}" class="text-white">
      <EnvelopeIcon  class="w-6 h-6" />
      <span class="btm-nav-label text-sm">{{__('Messages')}}</span>
      <div class="badge badge-error w-5 h-5 absolute top-0 left-5" v-if="user.notification_count > 0">{{user.notification_count}}</div>
    </router-link>
    <label for="my-drawer" class="text-white">
      <SquaresPlusIcon class="w-6 h-6" />
      <span class="btm-nav-label text-sm">{{__('Dashboard')}}</span>
    </label>
  </div>
</template>
<script setup>
import { inject } from 'vue';
import {HomeIcon,ShoppingBagIcon,EnvelopeIcon,SquaresPlusIcon,PercentBadgeIcon} from '@heroicons/vue/24/outline'
const specialTitle = window.nikran.special_title;
defineProps(['user']);
const backgroundColor = window.backgroundColor;
</script>